import { ElMessage } from 'element-plus'
import { t } from '@/plugins/i18n'
import { ref, Ref } from 'vue'

export default (
  commit: () => void,
  formRef = ref()
): [Ref, () => void, () => Promise<unknown>] => {
  const wrap = () => {
    const f = formRef.value
    f.validate((valid: boolean) => {
      if (valid) {
        commit()
      }
    })
  }
  const valid = (msg = '') =>
    new Promise((resolve) => {
      const f = formRef.value
      f.validate(resolve)
    }).then((res) => {
      if (!res && msg) {
        ElMessage.error(t(msg))
      }
      return res
    })
  return [formRef, wrap, valid]
}
